module.exports = __webpack_public_path__ + "img/qr-etiquetas.fce9be2b.png";